import React from 'react';

const Terms = () => {
  return (
    <main className="main-content">
      <div className="tos-page">
        <div className="tos-content">
          <h1>Terms of Service</h1>
          <p>Last updated: February 2, 2026</p>

          <h2>1. Before Purchasing</h2>
          <p>
            By accessing or using our services, you agree to these Terms of Service and all applicable policies.
            Our terms may be updated from time to time. Continued use of our services constitutes acceptance of the updated terms.
            This website is not affiliated with, authorized, sponsored, or endorsed by Discord Inc. or any of its subsidiaries.
          </p>
          <p>
            By placing an order you confirm that:
          </p>
          <p>
            — The boosts are delivered to your <strong>server</strong>, NOT to your personal Discord account.<br/>
            — Boosts <strong>cannot be transferred</strong> to another server once delivered.<br/>
            — The boosting accounts will <strong>not be kicked or banned</strong> from your server. If they are, boosts will be lost with no replacement or refund.<br/>
            — You have <strong>disabled all anti-raid and verification systems</strong> (Wick, Captcha.bot, AltDentifier, etc.) before your order is processed. Failed deliveries caused by active anti-raid will not be replaced or refunded.
          </p>

          <h2>2. Support Policy</h2>
          <p>
            Customer support is provided through our official channels:
            our <a href="https://discord.fastboost.cc/" target="_blank" rel="noopener noreferrer">Discord server</a>,
            our <a href="https://telegram.fastboost.cc/" target="_blank" rel="noopener noreferrer">Telegram</a>,
            and our support email (<a href="mailto:support@fastboost.cc">support@fastboost.cc</a>).
            We aim to respond to all inquiries within 24 hours.
          </p>

          <h2>3. Return &amp; Refund Policy</h2>
          <p>
            Due to the digital nature of our services, refunds are evaluated on a case-by-case basis.
          </p>
          <p>
            A refund may be offered if the service was not delivered as described, or a technical issue on our side prevented successful delivery.
          </p>
          <p>
            Refunds will not be issued if the service has been successfully delivered, issues arise due to customer-provided information or server configuration,
            boosting accounts were kicked or banned from the server, anti-raid or verification systems interfered with delivery,
            or circumstances are outside of our reasonable control.
          </p>

          <h2>4. Replacement Policy</h2>
          <p>
            Free replacements are offered only if boosts are lost due to an issue on our end, and only within the active boost duration period.
            No replacement will be provided if boosting accounts were kicked or banned, your server was deleted, or anti-raid systems caused the removal.
          </p>

          <h2>5. Payment &amp; Privacy</h2>
          <p>
            All payments are processed in cryptocurrency through secure third-party providers. We do not store payment credentials.
            We collect only the information necessary to process your order (email address, server invite link) and do not sell or share it with third parties.
          </p>

          <h2>6. Other Reminders</h2>
          <p>
            Product availability, pricing, and features may change at any time. If a change affects an active order, you will be notified through our support channels.
          </p>
          <p>
            By purchasing, you automatically accept these Terms of Service.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Terms;